<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Expedição</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                :class="{ visible: getSubMenuShowHideFw() }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                        @click="onAgrupa()"
                        v-b-tooltip
                        title="Agrupar Cargas"
                    ><i class="fa fa-object-group"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('expedicao.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('expedicao.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'doc_fiscal'">
                  </vuetable-filterbar>
                  <spinner
                    v-if="loadingDataExpedir"
                    text-fg-color="#ffffff"
                    message="Carregando..."
                  ></spinner>
                  <spinner
                    v-if="loading"
                    text-fg-color="#000000"
                    message="Carregando..."
                  ></spinner>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                      :key="tableKey"
                      ref="vuetable"
                      :load-on-start="false"
                      :fields="fields"
                      :css="css"
                      :append-params="moreParams"
                      :api-url="expedicaoApiUrl"
                      track-by="cargaId"
                      pagination-path="meta"
                      detail-row-component="expedicao-detalhes"
                      no-data-template="Nenhum dado encontrado. Escolha um filtro indicado ou atualize a página."
                      @vuetable:load-error="onError"
                      @vuetable:pagination-data="onPaginationData"
                      @vuetable:loaded="onLoaded"
                      class="table-responsive-sm"
                  >
                    <template slot="transportadora" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.pessoa !== null &&
                          props.rowData.pessoa.pessoaJuridica !== null
                        "
                        >PJ /
                        {{ props.rowData.pessoa.pessoaJuridica.razaoSocial }}
                        CNPJ:
                        {{
                          formatCnpjForDisplay(
                            props.rowData.pessoa.pessoaJuridica.cnpjBase,
                            props.rowData.pessoa.pessoaJuridica.cnpjFilial,
                            props.rowData.pessoa.pessoaJuridica.cnpjDigito
                          )
                        }}
                        IE:
                        {{
                          props.rowData.pessoa.pessoaJuridica.inscricaoEstadual
                        }}</span
                      >
                      <span
                        v-if="
                          props.rowData.pessoa !== null &&
                          props.rowData.pessoa.pessoaFisica !== null
                        "
                        >PF / {{ props.rowData.pessoa.pessoaFisica.nome }} -
                        {{ props.rowData.pessoa.pessoaFisica.cpf }}</span
                      >
                      <span
                        v-if="
                          props.rowData.pessoa !== null &&
                          props.rowData.pessoa.pessoaExterior !== null
                        "
                        >PE / {{ props.rowData.pessoa.pessoaExterior.nome }} -
                        {{ props.rowData.pessoa.pessoaExterior.cd }}</span
                      >
                      <span v-if="props.rowData.pessoa == null"
                        >Sem transportadora vinculada</span
                      >
                    </template>
                    <template slot="meioTranspPri" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.cargaMeioTransp !== null &&
                          props.rowData.cargaMeioTransp.veiculoMotorista !==
                            null &&
                          props.rowData.cargaMeioTransp.veiculoMotorista !==
                            null &&
                          props.rowData.cargaMeioTransp.veiculoMotorista
                            .veiculo !== null &&
                          props.rowData.cargaMeioTransp.veiculoMotorista.veiculo
                            .paramTipoRodado !== null
                        "
                        >{{
                          props.rowData.cargaMeioTransp.veiculoMotorista.veiculo
                            .paramTipoRodado.descr
                        }}
                        -
                        {{
                          formatNumber(
                            props.rowData.cargaMeioTransp.veiculoMotorista
                              .veiculo.paramTipoRodado.capacidadePeso
                          )
                        }}
                        KG
                      </span>
                    </template>
                    <template slot="unidade" slot-scope="props">
                      <span v-if="props.rowData.cargaUnidade !== null">{{
                        props.rowData.cargaUnidade.unidade
                      }}</span>
                    </template>
                    <template slot="dtExpedicao" slot-scope="props">
                      <span v-if="props.rowData.dtExpedicao !== null">{{
                        formatDateSeconds(props.rowData.dtExpedicao)
                      }}</span>
                    </template>
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 3"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="statusProcessoExpedicao" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.statusProcessoExpedicao.valor == 3"
                        >{{ props.rowData.statusProcessoExpedicao.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.statusProcessoExpedicao.valor == 2"
                        >{{ props.rowData.statusProcessoExpedicao.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.statusProcessoExpedicao.valor == 1"
                        >{{ props.rowData.statusProcessoExpedicao.descr }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <ExpedicaoRowActions
                        :row-data="props.rowData"
                        :permite-gerar-doc="permiteGerarDoc"
                        :permite-gerar-despesa="permiteGerarDespesa"
                        @edit="onEdit"
                        @create-scan="onCreate($event, 2)"
                        @checagem-cte="onCreateChecagemCte"
                        @checagem-nfs="onCreateChecagemNfs"
                        @store="onStoreFromRow"
                        @cancel-montagem="onCancelaMontagemCarga"
                        @imprimir-romaneio="onImprimirRomaneio"
                        @imprimir-provisorio="onImprimirRomaneioProvisorio"
                        @imprimir-manifesto="onImprimirManifesto"
                        @sequencia="sequenciaExpedicao"
                        @gerar-doc="onGerarDoc"
                        @compra-pedagio="onCompraPedagioAvulso"
                        @integracao="onIntegracaoFromRow"
                        @cancel-nstech="onCancelarCargaNstech"
                        @estorna-calculo="onEstornaCalculo"
                        @gera-ciot="onGeraCiot"
                        @cancel-expedicao="onCancelaExpedicao"
                        @detail="onDetailFromRow"
                        @reenviar-itrack="onReenviarItrack"
                        @validate-cte="onValidateDefaultCte"
                        @reenviar-mdfe="onReenviarItrackMdfe"
                        @reenvio-trn="onReenvioTrnDocFis"
                        @desagrupa="onDesagrupaCarga"
                        @envia-frete-avulso="onEnviaFreteAvulso"
                      />
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                          v-if="filterApplied"
                          ref="paginationInfo"
                          :css="css.pagination"
                          info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                          v-if="filterApplied"
                          ref="pagination"
                          :css="css.pagination"
                          @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ExpedicaoForm ref="expedicaoform" />
      <MontagemCargaForm ref="montagemcargaform" />
      <ChecagemCteCarga ref="checagemctecarga" />
      <ChecagemNfsCarga ref="checagemnfscarga" />
      <ExpedicaoCargaForm ref="expedicaocargaform" />
      <ExpedicaoSequenciaForm ref="expedicaosequenciaform" />
      <ExpedicaoModalPagamentoTarget ref="expedicaomodalpagamentotarget" />
      <ExpedicaoFreteAvulso ref="expedicaofreteavulso" />
    </div>
  </div>
</template>

<script>
import "./expedicao/registerExpedicaoDetailRow";
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import ExpedicaoFilterBar from "./ExpedicaoFilterBar";
import moment from "moment";
import accounting from "accounting";
import ExpedicaoRowActions from "./ExpedicaoRowActions";
import { formatCnpjForDisplay } from "../utils/expedicaoFormatters";
import { expedicaoEndpoints } from "../services/expedicaoEndpoints";
import { createExpedicaoVuetableFields } from "./expedicao/expedicaoVuetableFields";

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    ExpedicaoRowActions,
    ExpedicaoForm: () =>
      import(/* webpackChunkName: "expedicao-modals" */ "./ExpedicaoForm"),
    MontagemCargaForm: () =>
      import(
        /* webpackChunkName: "expedicao-modals" */ "./MontagemCargaForm"
      ),
    ExpedicaoCargaForm: () =>
      import(
        /* webpackChunkName: "expedicao-modals" */ "./ExpedicaoCargaForm"
      ),
    ChecagemCteCarga: () =>
      import(/* webpackChunkName: "expedicao-modals" */ "./ChecagemCteCarga"),
    ChecagemNfsCarga: () =>
      import(/* webpackChunkName: "expedicao-modals" */ "./ChecagemNfsCarga"),
    ExpedicaoSequenciaForm: () =>
      import(
        /* webpackChunkName: "expedicao-modals" */ "./ExpedicaoSequenciaForm"
      ),
    ExpedicaoModalPagamentoTarget: () =>
      import(
        /* webpackChunkName: "expedicao-modals" */ "./ExpedicaoModalPagamentoTarget"
      ),
    ExpedicaoFreteAvulso: () =>
      import(
        /* webpackChunkName: "expedicao-modals" */ "./ExpedicaoFreteAvulso"
      ),
    "vuetable-filterbar": ExpedicaoFilterBar,
  },
  data() {
    return {
      expedicaoApiUrl: expedicaoEndpoints.list,
      filterApplied: false,
      tableKey: 0,
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      peso_bruto: "",
      checkbox: [],
      permiteGerarDoc: true,
      permiteGerarDespesa: true,
      loading: false,
      isDisabled: false,
      loadingData: false,
      loadingDataExpedir: false,
      showModal: false,
      optionsMeioTransp: [],
      optionsStatusProcessoExpedicao: [],
      optionsTipoCarga: [],
      optionsUnidade: [],
      optionsTipoNf: [],
      optionsMunicipio: [],
      optionsPessoaParceira: [],
      optionsRegiao: [],
      optionsTpRodado: [],
      optionsVeiculo: [],
      optionsUf: [],
      dados: {},
      form: new Form({
        carga_id: "",
        pesmot_id: "",
        vlr_total_nfs: 0,
        ignora_nfs_canceladas: "",
        vlr_total_peso_liquido: 0,
        vlr_total_peso_bruto: 0,
        vlr_total_volume: 0,
      }),
      formreenviaritrack: new Form({
        carga_id: "",
        manifesto_id: "",
      }),
      helpForm: new Form({
        tp_pagamento: "",
        recordCollection: [],
        carga_id: "",
        manifesto_id: [],
        tipo: "",
        status: "",
        tp_agrupamento: "",
        cargaCollection: [],
      }),
      fields: createExpedicaoVuetableFields(),
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this._expedicaoFilterResetHandler = () => this.onFilterReset();
    this._expedicaoFilterSetHandler = (eventData) =>
      this.onFilterSet(eventData);
    this.$events.$on("filter-reset", this._expedicaoFilterResetHandler);
    this.$events.$on("filter-set", this._expedicaoFilterSetHandler);
    const cached = this.$store.state.expedicaoLivGeral;
    if (cached) {
      this._populateLivSimple(cached);
    } else {
      this.getLivSimple();
    }
  },
  beforeDestroy() {
    if (this._expedicaoFilterResetHandler) {
      this.$events.$off("filter-reset", this._expedicaoFilterResetHandler);
    }
    if (this._expedicaoFilterSetHandler) {
      this.$events.$off("filter-set", this._expedicaoFilterSetHandler);
    }
  },
  methods: {
    dispatchReturnApi(...args) {
      return new ReturnApi(...args);
    },
    formatCnpjForDisplay,
    onStoreFromRow(payload) {
      this.onStore(payload.cargaId, payload.cargaMeioTransp, payload.numCarga);
    },
    onIntegracaoFromRow({ rowData, tipo }) {
      this.onEventoIntegracao(rowData, tipo);
    },
    onDetailFromRow(data) {
      this.onDetail(data, null, null);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onReenviarItrack(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.formreenviaritrack.carga_id = carga_id;
      this.formreenviaritrack
        .post(expedicaoEndpoints.reenviaritrack)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, null, null, false);
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, null, null, false);
        });
    },
    onValidateDefaultCte(shipmentId) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.carga_id = shipmentId;
      this.helpForm
        .post(expedicaoEndpoints.gerarDocumentos(shipmentId))
        .then((response) => {
          this.dispatchReturnApi(response, this, true, null, null, false);
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, null, null, false);
        });
    },
    onReenvioTrnDocFis(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.carga_id = carga_id;
      this.helpForm
        .post(expedicaoEndpoints.reenviotrndocfis)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, null, null, false);
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, null, null, false);
        });
    },
    onReenviarItrackMdfe(manifesto_id) {
      this.loading = true;
      this.isDisabled = true;
      this.formreenviaritrack.manifesto_id = manifesto_id;
      this.formreenviaritrack
        .post(expedicaoEndpoints.reenviaritrackmdfe)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, null, null, false);
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, null, null, false);
        });
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.filterApplied = true;
      this.loadingData = true;

      this.moreParams = {
        observacao: data_filter.observacao,
        dt_emi_ini: data_filter.dt_emi_ini,
        regiao: data_filter.regiao,
        redespacho: data_filter.redespacho,
        dt_emi_fim: data_filter.dt_emi_fim,
        num_carga: data_filter.num_carga,
        consulta_completa: data_filter.consulta_completa,
        unidade: data_filter.unidade.value,
        status_processo_expedicao: data_filter.status_processo_expedicao.value,
        transportadora: data_filter.transportadora.pessoa_id,
      };
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.filterApplied = true;
      this.loadingData = true;
      this.moreParams = {};

      Vue.nextTick(() => {
        if (this.$refs.vuetable) {
          this.$refs.vuetable.selectedTo = [];
          this.$refs.vuetable.resetData();
        }
        if (this.$refs.pagination) {
          this.$refs.pagination.resetData();
        }
      });
      this.loadingData = false;
    },
    onLoaded() {
      this.loadingData = false;
    },
    onEdit(data) {
      this.$refs.expedicaoform.onEdit(data);
    },
    onCreate(carga_id, tipo) {
      this.$refs.expedicaocargaform.onCreate(carga_id, tipo);
    },
    onStore(carga_id, cargaMeioTransp, num_carga) {
      let motorista = "";
      let pesmot_id = "";

      if (
        cargaMeioTransp != null &&
        cargaMeioTransp.veiculoMotorista != null &&
        cargaMeioTransp.veiculoMotorista.pessoaMotorista != null &&
        cargaMeioTransp.veiculoMotorista.pessoaMotorista.pessoaFisica != null
      ) {
        motorista =
          cargaMeioTransp.veiculoMotorista.pessoaMotorista.pessoaFisica.nome;
        pesmot_id =
          cargaMeioTransp.veiculoMotorista.pessoaMotorista.pesmotId;
      }

      const mensagem =
        motorista === ""
          ? "Você deseja confirmar a expedição para a carga " +
            num_carga +
            "? Não há motorista vinculado."
          : "Você deseja confirmar a expedição para o motorista " +
            motorista +
            " na carga " +
            num_carga +
            "?";

      const appendErrorsToVm = (vm, errPayload) => {
        vm.errors_array = [];
        Object.keys(errPayload).forEach((property) => {
          if (typeof errPayload[property] === "object") {
            errPayload[property].forEach((obj) => {
              vm.errors_array.push({
                erro: obj,
              });
            });
          }
        });
      };

      const confirmAcaoNfsCanceladas = () => {
        this.loading = true;
        this.isDisabled = true;
        this.form.carga_id = carga_id;
        this.form.ignora_nfs_canceladas = 1;
        this.form.pesmot_id = pesmot_id;
        this.form
          .post(expedicaoEndpoints.store)
          .then((response) => {
            this.dispatchReturnApi(response, this);
            this.$parent.onFilterReset();
          })
          .catch((error_) => {
            this.dispatchReturnApi(error_, this, true, null, null, false);
            appendErrorsToVm(this, error_);
          });
      };

      const confirmAcao = () => {
        this.loading = true;
        this.isDisabled = true;
        this.form.carga_id = carga_id;
        this.form.ignora_nfs_canceladas = 2;
        this.form.pesmot_id = pesmot_id;
        this.form
          .post(expedicaoEndpoints.store)
          .then((response) => {
            this.dispatchReturnApi(response, this);
            this.$parent.onFilterReset();
          })
          .catch((error_) => {
            if (error_.has_nfs_canceladas) {
              this.loading = false;
              this.isDisabled = false;
              const obj2 = {
                title:
                  "Você deseja confirmar a expedição com notas canceladas?",
                message: error_.message,
                customConfirmBtnText: "Sim",
                customCloseBtnText: "Não",
                type: "warning",
                useConfirmBtn: true,
                onConfirm: confirmAcaoNfsCanceladas,
              };

              this.$Simplert.open(obj2);
            } else {
              this.dispatchReturnApi(error_, this, true, null, null, false);
              appendErrorsToVm(this, error_);
            }
          });
      };

      const obj = {
        title: "Confirmar Expedição ?",
        message: mensagem,
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "info",
        useConfirmBtn: true,
        onConfirm: confirmAcao,
      };

      this.$Simplert.open(obj);
    },
    onCreateChecagemCte(cargaId) {
      this.$refs.checagemctecarga.onCreate(cargaId);
    },
    onCreateChecagemNfs(cargaId) {
      this.$refs.checagemnfscarga.onCreate(cargaId);
    },
    onImprimirRomaneio(data) {
      this.isDisabled = true;
      this.loadingData = true;
      this.helpForm.carga_id = data.cargaId;
      this.helpForm
        .post(expedicaoEndpoints.romaneioImprimir)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, false, false, false);
          this.loadingData = false;
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, null, null, false);
          this.loadingData = false;
        });
    },
    onImprimirRomaneioProvisorio(data) {
      this.isDisabled = true;
      this.loadingData = true;
      this.helpForm.carga_id = data.cargaId;
      this.helpForm
        .post(expedicaoEndpoints.romaneioProvisorioImprimir)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, false, false, false);
          this.loadingData = false;
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, null, null, false);
          this.loadingData = false;
        });
    },
    onImprimirManifesto(manifestoIds) {
      if (!Array.isArray(manifestoIds) || !manifestoIds.length) {
        return;
      }
      this.helpForm.manifesto_id = manifestoIds;
      this.helpForm
        .post(expedicaoEndpoints.mdfeImprimir)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, false, false, false);
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this);
        });
    },
    onCancelaMontagemCarga(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.carga_id = carga_id;
      this.helpForm
        .patch(expedicaoEndpoints.montagemCargaCancelar)
        .then((response) => {
          this.dispatchReturnApi(response, this);
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this);
        });
    },
    getLivSimple() {
      this.helpForm
        .get("/api/expedicao/jsonlistsimple")
        .then((response) => {
          this.dispatchReturnApi(response, this, true, false, false);
          this._populateLivSimple(response);
        })
        .catch((error_) => {
          console.log("Erro aqui", error_);
          this.dispatchReturnApi(error_, this);
        });
    },
    _populateLivSimple(response) {
      this.optionsMeioTransp = [];
      this.optionsVeiculo = [];
      this.optionsTpRodado = [];
      this.optionsPessoaParceira = [];
      this.optionsRegiao = [];
      this.optionsUnidade = [];
      this.optionsStatusProcessoExpedicao = [];
      response.tp_rodado.forEach((obj) => {
        this.optionsTpRodado.push({
          label: obj.descr,
          value: obj.partiprod_id,
          tp_rodado: obj.tp_rodado,
        });
      });
      response.pessoa_parceira.forEach((obj) => {
        this.optionsPessoaParceira.push({
          label: obj.descr,
          value: obj.pespar_id,
        });
      });
      response.regiao.forEach((obj) => {
        this.optionsRegiao.push({
          label: obj.cd + ' - ' + obj.descr,
          value: obj.regiao_id,
        });
      });
      response.unidade.forEach((obj) => {
        this.optionsUnidade.push({
          label: obj.descr,
          value: obj.unidade_id,
        });
      });
      response.status_processo_expedicao.forEach((obj) => {
        this.optionsStatusProcessoExpedicao.push({
          label: obj.descr,
          value: obj.valor,
        });
      });
    },
    onAgrupa() {
      this.helpForm.cargaCollection = [];
      this.$refs.vuetable.selectedTo.forEach((obj) => {
        this.helpForm.cargaCollection.push(obj);
      });
      this.helpForm.tp_agrupamento = 1;
      this.helpForm
        .post(expedicaoEndpoints.agrupar)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, null, null, false);
        })
        .catch((error_) => {
          if (error_.tp_message === "error") {
            this.dispatchReturnApi(error_, this, false, false, false, false);
          } else if (error_.tp_message === "success") {
            this.dispatchReturnApi(error_, this, false, false, true, false);
          } else {
            const message = error_.message;

            const confirmDesassociarFn = () => {
              this.loading = true;
              this.helpForm.tp_agrupamento = 2;
              this.helpForm
                .post(expedicaoEndpoints.agrupar)
                .then((response) => {
                  this.dispatchReturnApi(
                    response,
                    this,
                    true,
                    false,
                    true,
                    false
                  );
                })
                .catch((agruparErr) => {
                  this.dispatchReturnApi(agruparErr, this);
                });
            };

            const obj = {
              title: "Atenção!",
              message,
              customConfirmBtnText: "Sim",
              customCloseBtnText: "Não",
              type: "info",
              useConfirmBtn: true,
              onConfirm: confirmDesassociarFn,
            };

            this.$Simplert.open(obj);
          }
        });
    },
    onDesagrupaCarga(data) {
      this.helpForm.carga_id = data;
      this.helpForm
          .post(expedicaoEndpoints.desagrupar)
          .then((response) => {
            this.dispatchReturnApi(response, this, true, false, true, false);
          })
          .catch((error_) => {
            this.dispatchReturnApi(error_, this, true, null, null, false);
          });
    },
    onGerarDoc(data) {
      this.helpForm.carga_id = data.cargaId;
      this.helpForm
        .post(expedicaoEndpoints.mdferomaneio)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, false, false);
          this.permiteGerarDoc = false;
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, null, null, false);
          this.permiteGerarDoc = false;
        });
    },
    onEstornaCalculo(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.carga_id = carga_id;
      this.form
        .post(expedicaoEndpoints.calculoEstornar)
        .then((response) => {
          this.dispatchReturnApi(response, this, true, false, false, false);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, false, false, false);
        });
    },
    onCancelarCargaNstech(rowData) {
      if (rowData.statusProcessoExpedicao.valor != 3) {
        this.$Simplert.open({
          title: "Atenção",
          message: "Processo de expedição em andamento, por favor aguarde para cancelar.",
          type: "warning",
        });
        return;
      }
      this.loading = true;
      this.isDisabled = true;
      this.helpForm
        .delete(expedicaoEndpoints.cancelarNstech(rowData.cargaId))
        .then((response) => {
          this.dispatchReturnApi(response, this, true, false, false, false);
        })
        .catch((error_) => {
          this.dispatchReturnApi(error_, this, true, false, false, false);
        });
    },
    onGeraCiot(data) {
      if (data.cargaRota.cargaRotaPedagio.length > 0) {
        this.$refs.expedicaomodalpagamentotarget.onCreate(data, "geraciot");
      } else {
        this.helpForm.carga_id = data.cargaId;
        this.helpForm.tp_pagamento = 0;
        this.helpForm
          .post(expedicaoEndpoints.geraciot)
          .then((response) => {
            this.dispatchReturnApi(response, this, true, false, false);
            this.$refs.vuetable.reload();
          })
          .catch((error_) => {
            this.dispatchReturnApi(error_, this);
          });
      }
    },
    onCompraPedagioAvulso(data) {
      this.$refs.expedicaomodalpagamentotarget.onCreate(data, "pedagioavulso");
    },
    onEnviaFreteAvulso(data) {
      let avulso = false;
      if (data.pessoa.pessoaTranspCalculo.length > 0) {
        data.pessoa.pessoaTranspCalculo.forEach((obj) => {
          if (obj.tpCalc === 8 && data.tpOperacaoPrincipal == obj.tpOperacao && obj.status == 1) {
            avulso = true;
          }
        });
      }
      if (avulso === true) {
        this.$refs.expedicaofreteavulso.onCreate(data);
      } else {
        this.onEventoIntegracao(data, 4);
      }
    },
    onCancelaExpedicao(data) {
      this.helpForm.carga_id = data.cargaId;
      this.helpForm
          .post(expedicaoEndpoints.cancelar)
          .then((response) => {
            this.dispatchReturnApi(response, this, true, false, false, false);
            this.onFilterReset();
          })
          .catch((error_) => {
            this.dispatchReturnApi(error_, this, true, false, false, false);
            this.onFilterReset();
          });
    },
    onEventoIntegracao(data, tipo) {
      this.helpForm.carga_id = data.cargaId;
      this.permiteGerarDespesa = false;
      this.helpForm.tipo = tipo;
      this.helpForm
          .post(expedicaoEndpoints.integracaoManual)
          .then((response) => {
            this.dispatchReturnApi(response, this, true, false, false);
            this.permiteGerarDespesa = false;
            this.onFilterReset();
          })
          .catch((error_) => {
            this.dispatchReturnApi(error_, this, true, false, false, false);
            this.permiteGerarDespesa = false;
            this.onFilterReset();
          });
    },
    sequenciaExpedicao(carga_id) {
      this.$refs.expedicaosequenciaform.getData(carga_id);
      this.$refs.expedicaosequenciaform.onView();
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.cargaId);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatDate(value, fmt = "DD MM YYYY") {
      return value == null ? "" : moment(value, "YYYY/MM/DD").format(fmt);
    },
    formatDateSeconds(value, fmt = "D/MM/YYYY HH:mm:ss") {
      return value == null
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm:ss").format(fmt);
    },
    onError(response) {
      this.dispatchReturnApi(response.response, this, true, true, false);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
  },
};
</script>
